globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { customImageLoader } from '@restworld/utils-common';
import { LinkBase } from '../link-base';
import { Title } from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ContactRestworldManager(props) {
  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var _props$rwManager = props.rwManager;
  _props$rwManager = _props$rwManager === void 0 ? {} : _props$rwManager;
  var email = _props$rwManager.email,
      firstName = _props$rwManager.firstName,
      lastName = _props$rwManager.lastName,
      phone = _props$rwManager.phone,
      _props$rwManager$imag = _props$rwManager.image,
      image = _props$rwManager$imag === void 0 ? '' : _props$rwManager$imag;
  return /*#__PURE__*/_jsxs(MainWrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      fontSize: "large",
      fontWeight: "semibold",
      textColor: "neutral-700",
      twStyle: {
        "marginBottom": "0.75rem",
        "width": "100%"
      },
      children: translateCommon('contact_your_restworld_manager')
    }), /*#__PURE__*/_jsx(Title, {
      textColor: "neutral-200",
      fontWeight: "medium",
      twStyle: {
        "marginBottom": "2rem"
      },
      children: "".concat(translateCommon('to_change_venue_details_or_manage_positions_contact_your_manager_immediately_via_live_chat_phone_or_email'), " ").concat(translateCommon('we_are_here_to_help_you'))
    }), /*#__PURE__*/_jsxs(InfoWrapper, {
      children: [/*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(Image, {
          src: image,
          alt: "",
          fill: true,
          loader: customImageLoader
        })
      }), /*#__PURE__*/_jsx(Title, {
        fontWeight: "semibold",
        textColor: "neutral-700",
        children: "".concat(translateCommon('the_contacts_of'), " ").concat(firstName, " ").concat(lastName)
      })]
    }), phone && /*#__PURE__*/_jsx(LinkBase, {
      newTab: false,
      link: "tel:".concat(phone),
      children: /*#__PURE__*/_jsx(Title, {
        icon: "PhoneIcon",
        textColor: "neutral-200",
        fontSize: "base",
        fontWeight: "medium",
        wrapperStyle: {
          "marginLeft": "auto",
          "marginRight": "auto",
          "marginBottom": "0.75rem",
          "width": "fit-content"
        },
        children: phone
      })
    }), email && /*#__PURE__*/_jsx(LinkBase, {
      newTab: false,
      link: "mailto:".concat(email),
      children: /*#__PURE__*/_jsx(Title, {
        icon: "EnvelopeIcon",
        textColor: "neutral-200",
        fontSize: "base",
        fontWeight: "medium",
        wrapperStyle: {
          "marginLeft": "auto",
          "marginRight": "auto",
          "marginBottom": "2rem",
          "width": "fit-content"
        },
        children: email
      })
    })]
  });
}
export default ContactRestworldManager;

var MainWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "contact-restworld-manager__MainWrapper",
  componentId: "sc-euytns-0"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "maxWidth": "28rem",
  "textAlign": "center"
});

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "contact-restworld-manager__ImageWrapper",
  componentId: "sc-euytns-1"
})(["", ""], {
  "position": "relative",
  "height": "2rem",
  "width": "2rem",
  "overflow": "hidden",
  "borderRadius": "9999px"
});

var InfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "contact-restworld-manager__InfoWrapper",
  componentId: "sc-euytns-2"
})(["", ""], {
  "marginBottom": "0.75rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem"
});